import React, { useRef, useEffect } from "react";
import { FloatingMenu } from "@darksnow-ui/menus";
import {
  useNodeTreeMenuItems,
  NodeMenuContext,
} from "../hooks/useNodeTreeMenuItems";
import { MenuItemConfig as NewMenuItemConfig } from "@darksnow-ui/menus";

export interface ContextMenuProps {
  x: number;
  y: number;
  nodeId: string;
  containerElementRef?: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  className?: string;
  onAction?: (action: string, nodeId: string) => void;
  items?: NewMenuItemConfig<NodeMenuContext>[];
  useDefaultItems?: boolean;
}

/**
 * Wrapper para o ContextMenu que integra com o node-tree
 */
export function ContextMenu({
  x,
  y,
  nodeId,
  containerElementRef,
  onClose,
  className,
  onAction,
  items,
  useDefaultItems = true,
}: ContextMenuProps) {
  const elementRef = useRef<HTMLDivElement>(null);

  // Obter items do menu usando o hook
  const { items: defaultItems, context } = useNodeTreeMenuItems(nodeId, {
    onAction,
  });

  // Determinar items finais
  const finalItems =
    items && items.length > 0
      ? (items as NewMenuItemConfig<NodeMenuContext>[])
      : useDefaultItems
        ? defaultItems
        : [];

  // Gerenciar foco
  useEffect(() => {
    // Manter o foco no container após fechar
    return () => {
      containerElementRef?.current?.focus();
    };
  }, [containerElementRef]);

  // Se não há items, não renderizar
  if (finalItems.length === 0) {
    return null;
  }

  return (
    <FloatingMenu
      items={finalItems}
      context={context}
      open={true}
      onOpenChange={(open: boolean) => !open && onClose()}
      x={x}
      y={y}
      className={className}
    />
  );
}
